import { z } from 'zod'
import interceptedAxios from '../../../utils/interceptedAxios'

const ZParameterConfig = z.object({
  id: z.string().nullable(),
  cimCodeId: z.string().nullable(),
  registerAddress: z.number().nullable(),
  parameterName: z.string().nullable(),
  type: z.string().nullable(),
  assetId: z.string().nullable().optional(),
  isRegisterEnabled: z.boolean(),
  isThisFromDefaultConfig: z.boolean(),
  pollingIntervalMinutes: z.number().nullable(),
  isAlarmApplicable: z.boolean().nullable(),
  isAlarmEnabled: z.boolean(),
  alarmLowerLimit: z.number().nullable(),
  alarmHigherLimit: z.number().nullable(),
  tenantId: z.string().nullable()
})

const ZApiResponse = z.object({
  error: z.boolean(),
  http_status: z.number(),
  data: z.array(ZParameterConfig)
})

export type ParameterConfig = z.infer<typeof ZParameterConfig>

// istanbul ignore next
export async function fetchParameterConfigs (
  assetId: string,
  assetTypeId: string,
  onSuccess: (configs: ParameterConfig[], httpStatus: number) => any,
  onFailure: (errorMessage: any, httpStatus: number) => any
): Promise<void> {
  const url = `/asset-config-service/api/v1/udp/tiq/commands/configuration/asset/${assetId}/paramconfig?assetTypeId=${assetTypeId}`
  interceptedAxios
    .get(url, { timeout: 15000 })
    .then((response: any) => {
      const parseResponse = ZApiResponse.safeParse(response.data)
      // istanbul ignore else
      if (parseResponse.success) {
        // istanbul ignore else
        if (
          parseResponse.data.data !== null &&
            parseResponse.data.data !== undefined
        ) {
          onSuccess(parseResponse.data.data, response.status)
        } else {
          onFailure(parseResponse.data.error, response.status)
        }
      } else {
        onFailure(parseResponse.error.message, response.status)
      }
    })
    .catch((error: any) => {
      onFailure(error.message, error.response.status)
    })
}
